export default {
  currentTeamsList(state) {
    return state.currentTeamsList;
  },
}